import { render, staticRenderFns } from "./publication.vue?vue&type=template&id=239e8a2a&scoped=true"
import script from "./publication.vue?vue&type=script&lang=js"
export * from "./publication.vue?vue&type=script&lang=js"
import style0 from "./publication.vue?vue&type=style&index=0&id=239e8a2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "239e8a2a",
  null
  
)

export default component.exports